import React from "react";
import { Col, Container, Row } from "react-bs4grid";

const ForgotPasswordSent = () => {
  return (
    <Container className="pt-32">
      <Row>
        <Col>
          <h1>Password Reset</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            We have sent you an email, with instructions on how to reset your
            password.
          </p>
          <p>Don't forget to check your spam folder.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPasswordSent;
